const LICENSE = '/gestao/licenca';

/**
 * A licenca guarda a aba na propria URL (`/gestao/licenca/{aba}`): assim a
 * aba aberta sobrevive ao F5 e pode ser mandada por link direto. Unidade e
 * modo continuam de query string em cima da aba "linhas".
 */
export const BILLING_ROUTES = {
  LICENSE,
  PLANS: `${LICENSE}/planos`,
  LINES: `${LICENSE}/linhas`,
  unit: (unitId: string) => `${LICENSE}/linhas?unidade=${unitId}`,
  unitSetup: (unitId: string) => `${LICENSE}/linhas?unidade=${unitId}&modo=configurar`,
} as const;
